import Footer from '../../components/footer';
import { Link } from '../../components/link';
import TopNav from '../../components/top-nav';
import { usePageTitle } from '../../utils/page-title';
import style from './style.module.scss';

export default function DeleteAccountPage() {
  usePageTitle('Delete Account');
  return (
    <>
      <TopNav isTransparent={false} />
      <div class={style.wrapper}>
        <h1>How to Delete your Adblock Podcast Account</h1>
        <p>
          Go to the{' '}
          <Link class="text-blue-500 underline" href="/account">
            Account Page
          </Link>
          , sign in, scroll to bottom, and press "Delete Account" button
        </p>
      </div>
      <Footer />
    </>
  );
}
